import { render, staticRenderFns } from "./InsumoSearch.vue?vue&type=template&id=0df000ab&"
import script from "./InsumoSearch.vue?vue&type=script&lang=js&"
export * from "./InsumoSearch.vue?vue&type=script&lang=js&"
import style0 from "./InsumoSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports